export default __webpack_public_path__ + "static/elysian_island_lockup-4ee86b8fec70f1f02553852288d22212.png";